import { useState } from 'react'
import icon from '../../../../img/font-style.png'
import { ColorPicker } from '../ColorPicker/ColorPicker'
export function FontStylePopup(props) {
    const [isOpenPopup, setIsOpenPopup] = useState(false)
    const onHandlerUpdateColor = (color) => {
        props.updateChoosedOptions({ fontColor: color })
    }
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    const changedFontStyle = (item) => {
        props.updateChoosedOptions(
            { fontStyle: item.font, 
            fontPrice: item.price, 
            })
    }
    return (

        <div className="option-popup__wrapper">
            <div className="option-popup__close" onClick={() => props.closePopup(null)}></div>
            <div className="option-popup__title flex items-center">
                <figure className="option-popup__icon">
                    <img src={icon} alt='size icon' />
                </figure>
                <h4>Font Style</h4>
            </div>
            <p>
                Select your font style from the options below
            </p>
            {props.choosedOptions.categoryPlate.includes("standard") &&
                <div className="option-popup__options grid">
                    {props.plateBuilder['font-family'].map((item) => {
                        if (item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) && (props.choosedOptions.plateMaterial === 'null' || item.material.includes(props.choosedOptions.plateMaterial))) {
                            return (
                                <div className={item.font === props.choosedOptions.fontStyle ? "option-popup__option--active option-popup__option" : " option-popup__option"} onClick={() => props.updateChoosedOptions({ fontStyle: item.font, fontPrice: item.price,})}>
                                    <div className="option-popup__option-icon">
                                        <img width='70' height='70' src={item.image} alt='font placeholder' />
                                    </div>
                                    <p>{item.name}</p>
                                </div>
                            )
                        }
                    })}
                </div>
            }
            {props.choosedOptions.categoryPlate.includes("show") &&
                <>
                    <p>Font Style</p>
                    <div className='font-dropdown' onClick={() => setIsOpenPopup(!isOpenPopup)}>
                        <div className='font-dropdown__head'>{props.choosedOptions.fontStyle !== 'null' ? props.plateBuilder['font-family'].map(item => {return  item.font === props.choosedOptions.fontStyle ? item.name : ''}) : 'Select Font Style'}</div>
                        {isOpenPopup &&
                            <div className='font-dropdown__content'>
                                {props.plateBuilder['font-family'].map((item) => {
                                    if (item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && (item.font !== 'Open Sans') && (props.choosedOptions.plateMaterial === 'null' || item.material.includes(props.choosedOptions.plateMaterial))) {
                                        return (
                                            <div 
                                            className={item.font === props.choosedOptions.fontStyle ? "font-dropdown__item--active font-dropdown__item" : " font-dropdown__item " +
                                            ((item.font === 'laser3d webfont' || item.font === 'Dome4D' || item.font === 'Dome5D') && props.choosedOptions.typeOfTransport === 'motorbike' ? 'hidden' : '') +
                                            ((item.font === 'laser3d webfont' || item.font === 'Dome4D' || item.font === 'Dome5D') && props.plateBuilder["plate-size"].find(size => {
                                                return size.size === props.choosedOptions.plateSizeRear && (size.material.includes('3D Domed') || size.material.includes('4D Raised') || size.material.includes('5D Raised'))
                                              }) ? '' : 'hidden') +
                                              ((item.font === 'laser3d webfont' || item.font === 'Dome4D' || item.font === 'Dome5D') && props.plateBuilder["plate-size"].find(size => {
                                                return size.size === props.choosedOptions.plateSizeFront && (size.material.includes('3D Domed') || size.material.includes('4D Raised') || size.material.includes('5D Raised'))
                                              }) ? '' : 'hidden') +
                                            ((item.font === 'Laser Charles Wright Carbon MC' || item.font === 'Laser Charles Wright3D MC') && props.choosedOptions.typeOfTransport === 'car' ? 'hidden' : '')} 
                                            onClick={() => changedFontStyle(item)}>
                                                <div className={classNames(
                                                    item.font === 'laser3d webfont' && 'font-3d',
                                                    item.font === 'Plate3d' && 'font-gray',
                                                    item.font === 'Charles Wright Carbon' && 'font-image',
                                                    item.font === 'Dome4D' && 'font-4d',
                                                    item.font === 'Dome5D' && 'font-5d',
                                                    item.font === 'laser inline webfont' && 'font-4d-cut',
                                                    'font-dropdown__name'
                                                )} style={{ "font-family": item.font }}>
                                                    <span>{item.name}</span>
                                                    {item.font === 'Plate3d' && <span>{item.name}</span>}
                                                    {item.font === 'Dome5D' && <span>{item.name}</span>}
                                                    {item.font === 'Dome5D' && <span>{item.name}</span>}
                                                </div>
                                            </div>
                                        )
                                    }
                                })}</div>
                        }
                    </div>
                {(props.choosedOptions.plateMaterial !== "Silver" &&
                    props.choosedOptions.plateMaterial !== "Black" &&
                    props.choosedOptions.plateMaterial !== "Silver Mirror" &&
                    props.choosedOptions.plateMaterial !== "Pressed Metal Black" &&
                    props.choosedOptions.plateMaterial !== "Pressed Metal" &&
                    props.choosedOptions.fontStyle !== 'laser3d webfont' && 
                    props.choosedOptions.fontStyle !== 'Dome4D' && 
                    props.choosedOptions.fontStyle !== 'Dome5D') &&
                    <>
                    <p>Font Colour</p>
                    <ColorPicker color={props.choosedOptions.fontColor} updateColor={onHandlerUpdateColor}></ColorPicker>
                    </>

                }
                </>
            }
            <div className="option-popup__btn flex justify-center"><div className="btn" onClick={() => props.closePopup(null)}>CONTINUE</div></div>

            {props.choosedOptions.categoryPlate.includes("standard") &&
                <div className="option-popup__switch-show">
                    <h6>Don’t see the font style you’re looking for?</h6>
                    <p>The fonts shown above are ‘Road compliant’ Standard fonts, but we can produce your number plates in a wide variety of different fonts and styles as part of our Show Plates range.</p>

                    <div className="option-popup__btn flex justify-center">
                        <div className=" btn btn--with-border" onClick={() => props.updateChoosedOptions({ categoryPlate: 'show', sloganName: '', showBSAU: 'false'  })}>SWITCH TO SHOW PLATES</div>
                    </div>
                </div>
            }
        </div>
    )
}